export const PRACTICE_SETTINGS_ROUTE_CONFIG = {
  "/howdoifeel": {
    sections: ["sound", "voice", "emotions", "timer"],
  },
  "/seeandhear": {
    sections: ["sound", "voice", "timer"],
  },
  "/actions": {
    sections: ["sound", "voice", "timer"],
  },
  "/performaction": {
    sections: ["sound", "voice"],
  },
};

export const PRACTICE_SETTINGS_PATHS = new Set(
  Object.keys(PRACTICE_SETTINGS_ROUTE_CONFIG),
);

export const PRACTICE_SETTINGS_DISABLED_PATHS = new Set([
  "/deepbreathe",
  "/deepbreathecopy",
  "/deepbreathe2",
  "/deepbreathe3",
  "/seeandhear2",
  "/congratulations",
  "/audioscreen",
]);
